<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :apiUrl="apiUrl"
      isChild>

      <template #form="scope">
        <div class="row">
          <div class="col">
            <div class="form-group input-group-sm">
              <label>Pendidikan</label>
              <v-select
                v-model="scope.data.EducationID"
                :options="listEducations"
                :reduce="item => item.ID"
                label="Name"/>
            </div>

            <div class="form-group input-group-sm">
              <label>Universitas</label>
              <input class="form-control d-block w-100" v-model="scope.data.University">
            </div>

            <div class="form-group input-group-sm">
              <label>Program Studi</label>
              <input class="form-control" v-model="scope.data.StudyProgram">
            </div>

            <div class="form-group input-group-sm">
              <label>Tanggal Masuk</label>
              <b-form-datepicker v-model="scope.data.Start" locale="id" size="sm" />
            </div>

            <div class="form-group input-group-sm">
              <label>Tanggal Keluar</label>
              <b-form-datepicker v-model="scope.data.End" locale="id" size="sm" />
            </div>

          </div>
        </div>

        <div class="text-right">
          <button type="submit" class="btn btn-sm btn-primary">Simpan</button>
        </div>
      </template>
    </AppToolbox>

    <AppTable
      :apiUrl="`${apiUrl}/get-employee/${this.$route.params.id}`"
      :fields="tableFields"
      :search="search"
      @onSelectItem="selectedItem = $event" />

  </div>

</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.fetchOptionData()

    this.scopedFormData.EmployeeID = parseInt(this.$route.params.id)
  },
  data() {
    return {
      apiUrl: '/employee-education',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Education', label: 'Pendidikan', formatter: (value) => value.Name },
        { key: 'University', label: 'Universitas' },
        { key: 'StudyProgram', label: 'Program Studi' },
        { key: 'Start', label: 'Mulai', formatter: value => this.$helper.formatDate(value) },
        { key: 'End', label: 'Akhir', formatter: value => this.$helper.formatDate(value) }
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        EducationID: null,
        University: '',
        StudyProgram: '',
        Start: new Date(),
        End: new Date()        
      },
      listEducations: [],
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    fetchOptionData () {
      this.$axios.all([
        this.$axios.get('/education')
      ]).then(this.$axios.spread((...res) => {
        this.listEducations = res[0].data
      }))
    }
  }
}
</script>
